import { MDBAlert, MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { _validMail } from "../../ayudas/validationes_varias"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';

const columns = [
    {
        label: "Acción",
        field: "handle"
    },
    {
        label: "id",
        field: "id"
    },
    {
        label: "Asociar",
        field: "asociado"
    },
    {
        label: "Nombre",
        field: "nombres"
    },
    {
        label: "Apellido",
        field: "apellidos"
    }
]

export default class UsuarioFormulario extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                first_name: '',
                last_name: '',
                username: '',
                email: '',
                password: ''

            },
            password2: null,
            colapsar: true,
            colapsarAsociarEmpresa: true,
            colapsarAsociarRol: true,
            colapsarAsociarColaborador: true,
            camposRequeridos: [],
            colaboradores: [],
            empresas: [],
            roles: []
        };
    }

    componentDidMount() {
        this.obtenerColaboradores();
        this.obtenerEmpresas();
        this.obtenerRoles();
    }

    obtenerColaboradores() {
        const registro = this.state.registro
        if (_valid(registro.id)) {
            this.apiRest.get('/usuarioColaboradores/' + registro.id).then(respuesta => {
                if (respuesta.exitoso) {
                    let data = this.agregarEstado(respuesta.data);
                    this.setState({ colaboradores: this.agregarAccionesRegistro(data) });
                }
            });
        }
    }

    agregarEstado = registro => {
        registro.forEach(registro => registro.asociado = this.Estado(registro.asociado));
        return registro;
    };

    Estado = registro => {
        if (registro === true) {
            return <CheckIcon style={{ color: "#4caf50" }} />;
        } else {
            return <CancelIcon style={{ color: "#D80A2A" }} />;
        }
    }

    obtenerEmpresas() {
        const registro = this.state.registro
        if (_valid(registro.id)) {
            this.apiRest.get('/usuarioEmpresas/' + registro.id).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ empresas: respuesta.data });
                }
            });
        }
    }

    obtenerRoles() {
        const registro = this.state.registro
        if (_valid(registro.id)) {
            this.apiRest.get('/usuarioRoles/' + registro.id).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ roles: respuesta.data });
                }
            });
        }
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    colapsarAsociarColaborador() {
        this.setState(estadoAnterior => ({ colapsarAsociarColaborador: !estadoAnterior.colapsarAsociarColaborador }));
    }

    colapsarAsociarEmpresa() {
        this.setState(estadoAnterior => ({ colapsarAsociarEmpresa: !estadoAnterior.colapsarAsociarEmpresa }));
    }

    colapsarAsociarRol() {
        this.setState(estadoAnterior => ({ colapsarAsociarRol: !estadoAnterior.colapsarAsociarRol }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    asociarColaborador = ({ target: { name, value, checked } }) => {
        const datos = {
            asociar: checked,
            idColaborador: value
        }
        console.log(datos)
        this.apiRest.put('/asociarUsuarioColaborador/' + this.state.registro.id, datos).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Colaborador ' + (checked ? 'asociado' : 'desasociado') + ' exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    asociarEmpresa = ({ target: { name, value, checked } }) => {
        const datos = {
            asociar: checked,
            idEmpresa: value
        }
        this.apiRest.put('/asociarUsuarioEmpresa/' + this.state.registro.id, datos).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Empresa ' + (checked ? 'asociado' : 'desasociado') + ' exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    asociarRol = ({ target: { name, value, checked } }) => {
        const datos = {
            asociar: checked,
            idRol: value
        }
        this.apiRest.put('/asociarUsuarioRol/' + this.state.registro.id, datos).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Rol ' + (checked ? 'asociado' : 'desasociado') + ' exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    almacenarRegistro = () => {
        if (this.datosRegistroValidos()) {
            const registro = this.state.registro
            if (registro.id !== undefined && registro.id !== null) {
                this.apiRest.put('/usuario/' + registro.id, registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            } else {
                if (this.verificarPassword()) {
                    this.apiRest.post('/usuario', registro).then(resultado => {
                        if (resultado.exitoso) {
                            toastr.success('Datos almacenados exitosamente!');
                            this.setState({ registro: resultado.data });
                            this.obtenerColaboradores();
                            this.obtenerEmpresas();
                            this.obtenerRoles();
                        } else {
                            toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                        }
                    });
                }
            }
        }
    }

    datosRegistroValidos() {
        const { registro, camposRequeridos } = this.state;

        let existenErrores = false
        if (!_valid(registro.username)) {
            camposRequeridos.push("Nombre de usuario");
            existenErrores = true;
        }
        if (!_valid(registro.id) && !_valid(registro.password)) {
            camposRequeridos.push("Contraseña");
            existenErrores = true;
        }

        if (existenErrores) {
            this.setState({ camposRequeridos: camposRequeridos });
            setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);
        }

        return !existenErrores;
    }

    editar = (registro) => {
        let indicador = false;
        indicador = _valid(this.state.registro.colaborador);
        if (indicador) {
            if (registro.id == this.state.registro.colaborador.id) {
                let checked = false;
                let value = registro.id
                const datos = {
                    asociar: checked,
                    idColaborador: value
                }
                this.setColaborador(datos);
            } else {
                let checked = true;
                let value = registro.id
                const datos = {
                    asociar: checked,
                    idColaborador: value
                }
                this.getColaborador(value, datos);
            }
        } else {
            let checked = true;
            let value = registro.id
            const datos = {
                asociar: checked,
                idColaborador: value
            }
            this.getColaborador(value, datos);
        }
    }

    actualizarValor = ({ target: { name, value } }) => {
        this.setState({ password2: value });
    }

    verificarPassword = () => {
        let estado = false
        let password = this.state.registro.password
        let password2 = this.state.password2
        if (_valid(password)) {
            if (_valid(password2)) {
                if (password === password2) {
                    estado = true
                } else {
                    toastr.error('La contraseña no es la misma al confirmar');
                }
            } else {
                toastr.error('Es necesario confirmar la contraseña');
            }
        } else {
            toastr.error('Campo Contraseña es requerido');
        }
        return estado
    }

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => registro.handle = this.boton(registro));
        return { columns, rows: rows };
    };

    boton = registro => [
        <MDBBtn className="waves-effect" size="sm" color="primary" title="Asociar" onClick={() => this.editar(registro)}>
            <MDBIcon icon="fas fa-link" />
        </MDBBtn>
    ];

    setColaborador(datos) {
        let first_name = 'Null';
        let last_name = 'Null';
        let email = 'demo@gmail.com';
        let username = this.state.registro.username
        const registro = {
            first_name,
            last_name,
            email,
            username
        }
        this.apiRest.put('/usuario/' + this.state.registro.id, registro).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ registro: resultado.data })
                this.getAsociacion(this.state.registro.id, datos);
            }
        });
    }

    //obtener colaborador y asociar id correo nombre
    getColaborador = (id, datos) => {
        this.apiRest.get('/colaborador/' + id).then(resultado => {
            if (resultado.exitoso) {
                let colaborador = resultado.data
                let first_name = colaborador.nombres;
                let last_name = colaborador.apellidos;
                let email = colaborador.mail_institucional
                let username = this.state.registro.username
                const registro = {
                    first_name,
                    last_name,
                    email,
                    username
                }
                this.getAsociacion(this.state.registro.id, datos);
                this.apiRest.put('/usuario/' + this.state.registro.id, registro).then(resultado => {
                    if (resultado.exitoso) {
                        this.setState({ registro: resultado.data })
                    }
                });
            }
        });
    }

    getAsociacion = (id, datos) => {
        this.apiRest.put('/asociarUsuarioColaborador/' + id, datos).then(resultado => {
            if (resultado.exitoso) {
                this.obtenerColaboradores();
                toastr.success('Colaborador ' + (datos.asociar ? 'asociado' : 'desasociado') + ' exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    render() {

        const {
            registro,
            colapsar,
            colapsarAsociarColaborador,
            colapsarAsociarEmpresa,
            colapsarAsociarRol,
            camposRequeridos,
            colaboradores
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Usuario" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Usuario</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        {
                                                            _valid(this.state.registro.colaborador) ?
                                                                <Row>
                                                                    <Col lg={4}>
                                                                        <div className="mb-3 mb-4">
                                                                            <Label htmlFor="first_name" className="form-label">
                                                                                Nombres
                                                                            </Label>
                                                                            <Input
                                                                                value={registro.first_name || ""}
                                                                                name="first_name"
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Ingresar nombres"
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={4}>
                                                                        <div className="mb-3 mb-4">
                                                                            <Label htmlFor="last_name" className="form-label">
                                                                                Apellidos
                                                                            </Label>
                                                                            <Input
                                                                                value={registro.last_name || ""}
                                                                                name="last_name"
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Ingresar apellidos"
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={4}>
                                                                        <div className="mb-3 mb-4">
                                                                            <Label htmlFor="email" className="form-label">
                                                                                Email
                                                                            </Label>
                                                                            <Input
                                                                                value={registro.email || ""}
                                                                                name="email"
                                                                                type="mail"
                                                                                className="form-control"
                                                                                placeholder="Ingresa tu email"
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                : ""
                                                        }
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="username" className="form-label">
                                                                        Nombre de usuario
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.username || ""}
                                                                        onChange={this.actualizarValores}
                                                                        name="username"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresar usuario"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="password" className="form-label">
                                                                        Contraseña
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.password || ""}
                                                                        onChange={this.actualizarValores}
                                                                        name="password"
                                                                        type="password"
                                                                        className="form-control"
                                                                        placeholder="Ingresar contraseña"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="password2" className="form-label">
                                                                        Confirmar Contraseña
                                                                    </Label>
                                                                    <Input
                                                                        value={this.state.password2 || ""}
                                                                        onChange={this.actualizarValor}
                                                                        name="password2"
                                                                        type="password"
                                                                        className="form-control"
                                                                        placeholder="Confirmar contraseña"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>

                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/usuarioListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Listo
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {
                            _valid(this.state.registro.id) ?
                                <Row>
                                    <Col className="col-12">
                                        <Card>
                                            <CardBody>
                                                <Link onClick={() => this.colapsarAsociarColaborador()} className="text-dark">
                                                    <div className="p-4">
                                                        <Media className="d-flex align-items-center">
                                                            <div className="me-3">
                                                                <i className="uil uil-receipt text-primary h2"></i>
                                                            </div>
                                                            <div className="flex-1 overflow-hidden">
                                                                <h5 className="font-size-16 mb-1">Asociar Colaborador</h5>
                                                            </div>
                                                            <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                        </Media>
                                                    </div>
                                                </Link>
                                                <Collapse isOpen={colapsarAsociarColaborador}>
                                                    {_valid(registro.first_name) && registro.first_name != 'Null' ? 'Colaborador Asociado: '+registro.first_name+' '+registro.last_name: 'Colaborador Asociado:'}
                                                    <div className="p-4 border-top">
                                                        <div className="table-responsive">
                                                            <MDBDataTable hover entriesOptions={[5, 20, 25]} entries={100} searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={colaboradores} />
                                                        </div>
                                                    </div>
                                                </Collapse>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                : ""
                        }
                        {
                            _valid(this.state.registro.id) ?
                                <Row>
                                    <Col className="col-12">
                                        <Card>
                                            <CardBody>
                                                <Link onClick={() => this.colapsarAsociarEmpresa()} className="text-dark">
                                                    <div className="p-4">
                                                        <Media className="d-flex align-items-center">
                                                            <div className="me-3">
                                                                <i className="uil uil-receipt text-primary h2"></i>
                                                            </div>
                                                            <div className="flex-1 overflow-hidden">
                                                                <h5 className="font-size-16 mb-1">Asociar Empresa</h5>
                                                            </div>
                                                            <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                        </Media>
                                                    </div>
                                                </Link>
                                                <Collapse isOpen={colapsarAsociarEmpresa}>
                                                    <div className="p-4 border-top">
                                                        <Table className="table table-sm m-0">
                                                            <thead>
                                                                <tr>
                                                                    <th width="15%">Asociar</th>
                                                                    <th>Empresa</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    this.state.empresas.map((empresa) =>
                                                                        <tr>
                                                                            <td className="text-center">
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    value={empresa.id}
                                                                                    onChange={this.asociarEmpresa}
                                                                                    defaultChecked={empresa.asociado}
                                                                                    className="form-control"
                                                                                />
                                                                            </td>
                                                                            <td>{empresa.nombre}</td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </Collapse>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                : ""
                        }
                        {
                            _valid(this.state.registro.id) ?
                                <Row>
                                    <Col className="col-12">
                                        <Card>
                                            <CardBody>
                                                <Link onClick={() => this.colapsarAsociarRol()} className="text-dark">
                                                    <div className="p-4">
                                                        <Media className="d-flex align-items-center">
                                                            <div className="me-3">
                                                                <i className="uil uil-receipt text-primary h2"></i>
                                                            </div>
                                                            <div className="flex-1 overflow-hidden">
                                                                <h5 className="font-size-16 mb-1">Asociar Rol</h5>
                                                            </div>
                                                            <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                        </Media>
                                                    </div>
                                                </Link>
                                                <Collapse isOpen={colapsarAsociarRol}>
                                                    <div className="p-4 border-top">
                                                        <Table className="table table-sm m-0">
                                                            <thead>
                                                                <tr>
                                                                    <th width="15%">Asociar</th>
                                                                    <th>Rol</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    this.state.roles.map((rol) =>
                                                                        <tr>
                                                                            <td className="text-center">
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    value={rol.id}
                                                                                    onChange={this.asociarRol}
                                                                                    defaultChecked={rol.asociado}
                                                                                    className="form-control"
                                                                                />
                                                                            </td>
                                                                            <td>{rol.name}</td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </Collapse>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                : ""
                        }
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}